<template>
  <a-flex gap="small" align="center" justify="center">
    <a v-for="item in links" :key="item.link" :href="item.link" target="_blank">
      <img :src="item.icon" :alt="item.market" />
    </a>
  </a-flex>
</template>

<script setup lang="ts">
import type { CombineProductsBySizeTableItem } from "@/stores/product/combineProducts/combineProductsBySize/combine-products-by-size.store";

defineProps<{
  links: CombineProductsBySizeTableItem["links"];
}>();
</script>

<style scoped lang="scss">
a {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: flex;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
